import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { getNotifications } from "../../redux/app/actions";

const Announcements = () => {
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);

  useEffect(() => {
    loadNotifications();
  }, []);

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  return (
    <>
      {websiteNotifications?.length > 0 ? (
        <div className="new-marquee">
          <Marquee speed={50} pauseOnHover={true}>
            {websiteNotifications?.map((notf, idx) => (
              <div
                key={idx}
                style={{
                  marginRight: "50px", // Adds space between each notification on the line
                  fontWeight: "500",
                }}
              >
                {notf?.content}
                {/* Optional: Add a little bullet or separator between items here if you want */}
              </div>
            ))}
          </Marquee>
        </div>
      ) : null}
    </>
  );
};
export default Announcements;
